import { useEffect, useState } from "react"
import { type ProductFilterInput } from "../../../type-and-hooks"

export const specialTypeSwap = <Type>(value: Type): boolean | Type => {
  if (typeof value === "string") {
    if (value === "Y") {
      return true
    }
    if (value === "N") {
      return false
    }
  }
  return value
}
interface UseDebounceTimerProps<A> {
  value: A
  debounceTime?: number
}
export const useDebounce = <A extends string | number | Partial<ProductFilterInput>>({ value, debounceTime = 500 }: UseDebounceTimerProps<A>): A => {
  const [debouncedValue, setDebouncedValue] = useState<A>(value)
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value)
    }, debounceTime)

    return () => {
      clearTimeout(timer)
    }
  }, [value, debounceTime])

  return debouncedValue
}
